import React, { useState, useRef, useEffect } from 'react';
import { SxProps, Typography, styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const TextContainer = styled('div')<{ isExpanded: boolean }>(({ isExpanded }) => ({
	overflow: 'hidden',
	position: 'relative',
	background: !isExpanded ? 'linear-gradient(to bottom, transparent, white)' : undefined,
	maskImage: !isExpanded ? 'linear-gradient(to bottom, black 50%, transparent 100%)' : undefined,
	WebkitMaskImage: !isExpanded
		? 'linear-gradient(to bottom, black 50%, transparent 100%)'
		: undefined,
	transition: !isExpanded
		? 'max-height mask-image 0.5s ease-in-out, -webkit-mask-image 0.5s ease-in-out'
		: undefined,
}));

const Text = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.primary,
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	transition: 'max-height 0.3s ease',
	textAlign: 'left',
}));

const LinkText = styled(Typography)(({ theme }) => ({
	color: theme.palette.primary.main,
	cursor: 'pointer',
	fontSize: 'var(--font-size-small)',
	marginTop: theme.spacing(1),
	marginBottom: theme.spacing(2),
	[theme.breakpoints.up('sm')]: {
		marginBottom: 0,
	},
	textAlign: 'center',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	textDecoration: 'underline',
}));

const IconSX: SxProps = {
	fontSize: 'var(--font-size-lg)',
};

export const DpSEOText = ({ children }: { children: React.ReactNode; sx?: SxProps }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const textRef = useRef<HTMLDivElement>(null);
	const handleExpandClick = () => {
		setIsExpanded(!isExpanded);
	};
	const [altura, setAltura] = useState(0);

	useEffect(() => {
		if (textRef.current) {
			setAltura(textRef.current.offsetHeight);
		}
	}, []);

	return (
		<React.Fragment>
			<TextContainer
				ref={textRef}
				sx={{ height: isExpanded ? 'none' : '136px' }}
				isExpanded={isExpanded}
			>
				<Text
					sx={{
						maxHeight: isExpanded ? 'none' : '136px',
						WebkitLineClamp: isExpanded ? 'none' : 15,
						overflow: isExpanded ? 'visible' : 'hidden',
						fontSize: 'var(--font-size-default)',
					}}
				>
					{children}
				</Text>
			</TextContainer>
			{altura >= 136 ? (
				<LinkText onClick={handleExpandClick}>
					{isExpanded ? 'Ver menos' : 'Ver más'}
					{isExpanded ? <KeyboardArrowUpIcon sx={IconSX} /> : <KeyboardArrowDownIcon sx={IconSX} />}
				</LinkText>
			) : null}
		</React.Fragment>
	);
};
